import type { Author } from "~/lib/authors";

type Props = Readonly<{
  authors: readonly Author[];
}>;

type Params = Readonly<{
  author: Author;
  zIndex: string;
  className?: string;
}>;

const Z_INDEX = [
  "z-0",
  "z-10",
  "z-20",
  "z-30",
  "z-40",
  "z-50",
  "z-60",
  "z-70",
  "z-80",
  "z-90",
  "z-100",
  "z-110",
];

export function Authors({ authors }: Props): JSX.Element {
  return (
    <div className="not-prose flex">
      {authors.map((a, i) => (
        <Avatar
          author={a}
          key={`${a.name}-${i}`}
          zIndex={Z_INDEX[authors.length - i]}
          className={authors.length > 10 ? `-mr-4 xs:-mr-3` : "-mr-3"}
        />
      ))}
    </div>
  );
}

function Avatar({ author, zIndex, className }: Params) {
  return (
    <div className={`relative ${className} ${zIndex} h-10 w-10`}>
      <div className="absolute t-0 l-0 bg-gray-100 dark:bg-black rounded-full h-10 w-10"></div>
      <img
        alt={`${author.name} | Brale`}
        className={`w-9 absolute top-[2px] left-[2px] rounded-full`}
        src={author.avatar}
      />
    </div>
  );
}
